import React from 'react';
import { TasksListItemType, TaskStatusEnum } from '@redux/tasks/tasksTypes';

export enum TasksTableColName {
  PATIENT_NAME = 'patientName',
  SCHEDULED_DATE = 'scheduledDate',
  FREQUENCY = 'frequency',
  TASK_TYPE = 'taskType',
  TASK_MESSAGE = 'taskMessage',
  TASK_NAME = 'taskName',
  PATIENT_RESPONSE = 'patientResponse',
  STATUS = 'status',
  DETAILS = 'details'
}

export type TasksTableData = TasksListItemType & {
  avatar?: string;
};

export type TaskMenuProps = {
  onSelectTask: () => void;
  onCancelTask: (isSingleCancel: boolean) => void;
  status: TaskStatusEnum;
  frequency: string;
};

export type TasksTableProps = React.ComponentPropsWithoutRef<'table'> & {
  data: TasksTableData[];
  onSelectTaskSwitch: (id?: string) => void;
  onCancelTask: (id: string, isSingleCancel: boolean) => void;
};
